import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoneyBill, faSync } from '@fortawesome/free-solid-svg-icons';
import { Article } from '@accounting/interfaces/article';
import BpcTaxTable from '@accounting/components/tables/tax-table/tax-table.vue';
import BpcAccountTable from '@accounting/components/tables/account-table/account-table.vue';
import BpcArticleTagTable from '@accounting/components/tables/article-tag-table/article-tag-table.vue';
import BpcArticleForm from '@accounting/components/forms/article-form/article-form.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import ArticleImpactModal from '@accounting/components/modals/article-impact-modal/article-impact-modal.vue';

library.add(faSync);
library.add(faMoneyBill);

@Component({
  name: 'bpc-article-table',
  components: {
    'bpc-article-impact-modal': ArticleImpactModal,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-extended-filter': ExtendedFilter,
    ValidationObserver,
    'bpc-tax-table': BpcTaxTable,
    'bpc-account-table': BpcAccountTable,
    'bpc-article-tag-table': BpcArticleTagTable,
    'bpc-article-form': BpcArticleForm,
    'bpc-drawer-modal': DrawerModal,
    'bpc-custom-filter-selector': CustomFilterSelector,
  },
})
export default class ArticleTable extends mixins(AbstractTable) {
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop({ type: String, default: null }) readonly categoryFilterConfigName: string;

  public entity: Article = null;
  public entityName = 'article';
  public pluralEntityName = 'articles';
  public permissionEntityNameToUse = 'articles';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public isFixedPrice: boolean = true;

  // Impacts processing
  isArticleImpactsEnabled: boolean = this.$store.getters['centerSettings/useArticleImpacts'];
  isProcessingImpacts: boolean = false;
  showImpactsModal: boolean = false;
  showImpactsButton: boolean = false;
  articleDataForImpact: Article = null;
  isProcessingImpactsRunning: boolean = false;
  isProcessingImpactsEnded: boolean = false;
  isProcessingImpactsFailed: boolean = false;
  totalCount: number = 0;
  processedCount: number = 0;
  ignoredCount: number = 0;
  impactsAlertKey: number = 0;

  get impactsAlertStatus(): string {
    if (this.isProcessingImpactsRunning) {
      return 'warning';
    } else if (this.isProcessingImpactsEnded) {
      return 'success';
    } else if (this.isProcessingImpactsFailed) {
      return 'danger';
    } else {
      return 'info';
    }
  }

  flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {
    settings: {
      activated: false,
      type: 'action',
      icon: 'cog',
      variant: 'secondary',
      text: null,
      show: true,
      event: 'settings',
      selectElements: false,
      tag: 'right',
    },
    articleImpacts: {
      activated: false,
      type: 'action',
      icon: 'cog',
      variant: 'warning',
      text: 'impact_orders',
      show: true,
      event: 'articleImpacts',
      selectElements: true,
      tag: 'middle',
    },
  };

  refreshTags = 0;
  refreshAccounts = 0;
  refreshTaxes = 0;

  onRefreshTags() {
    this.refreshTags++;
  }

  onRefreshAccounts() {
    this.refreshAccounts++;
  }

  onRefreshTaxes() {
    this.refreshTaxes++;
  }

  /**
   * Overwrite method of abstract-table to add eventos for custom page actions.
   * @param $event
   */
  customOnPageAction($event: string) {
    switch ($event) {
      case 'settings':
        this.onArticleSetting();
        break;
      case 'articleImpacts':
        this.onArticleImpacts();
        break;
    }
    console.log('Page Title event >>> ' + $event);
  }

  onArticleSetting() {
    // this.crudEntitySetting = entity;
    this.showSettingForm = true;
    this.showDrawerSettingSection = true;
  }

  onSettingFormClose() {
    this.showSettingForm = false;
    this.showDrawerSettingSection = false;
  }

  onArticleImpacts() {
    console.log('table -> show modal !!');
    this.showImpactsModal = true;
    this.$bvModal.show('article-impact-modal');
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Article;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(newEntity, 'price_type', 'fixed');
    this.$set(newEntity, 'articlePrices', null);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onNew() {
    this.$bpcStorage.clear('article-prices');
    this.$bpcStorage.clear('article-true-costs');
    this.entity = null;
    this.isFixedPrice = true;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    this.$bpcStorage.clear('article-prices');
    this.$bpcStorage.clear('article-true-costs');
    console.log('clickOnEdit', e);
    this.entity = e.item;
    this.isFixedPrice = e.item.price_type_value === 'fixed';
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  onFormClose() {
    this.showForm = false;
    this.showDrawerSection = false;
    this.i++;
    this.isSavingForm = false;
    this.showImpactsButton = false;
  }

  /* Lifecycle hooks */

  // created() {}
  mounted() {
    this.exportCheckoutModalId = this.generateUUIDv4();
    this.$root.$on('updatePriceType', event => {
      this.isFixedPrice = event === 'fixed';
    });
    this.$root.$on('show-article-impact-alert', () => {
      if (this.isArticleImpactsEnabled) {
        this.showImpactsButton = true;
      }
    });
    this.listenToWebsocketArticleImpactChannel();
  }

  destroyed() {
    this.$root.$off('updatePriceType');
    this.$root.$off('show-article-impact-alert');
    this.leaveWebsocketImportCodaFileChannel();
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.articleImpacts.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$store.getters['auth/isSuperAdmin'];
  }
  extendUpdateRowActions(entity) {
    // POS Checkout
    const hasPosCheckoutPermission = this.$authorizationService.hasPermissionForAction(
      'pos_sessions',
      'pos_checkout',
      true,
    );

    entity.actions['posCheckout'].show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      hasPosCheckoutPermission &&
      !!this.openPosSession &&
      ['material', 'other'].includes(entity.article_type_value);
  }

  onExportToPosCheckout(item) {
    if (!this.disabled) {
      this.selectedArticleIdToPosCheckout = item?.item?.id;
      this.$store.commit('pos/storeArticleToAdd', item?.item || []);
      if (this.withConfirmationModal) {
        this.openExportPosCheckoutModal();
      } else {
        this.selectedInvoiceIdToPosCheckout = this.$store.getters['pos/currentTicketId'];
        this.onConfirmAddArticleToCurrentPosTicket();
      }
    }
  }

  onFormSavedCustom($event = null) {
    if (this.nextAction === 'article-impact') {
      console.warn('ARTICLE IMPACT !!! ' + $event.data?.id);
      this.articleDataForImpact = $event.data;
      this.onFormClose();
      this.$refs.provider.getEntities();
      this.showImpactsModal = true;
      this.$bvModal.show('article-impact-modal');
    } else {
      this.onFormSaved($event);
    }
  }

  onFormBulkSavedCustom($event: any = null) {
    if (this.nextAction === 'article-impact') {
      console.warn('ARTICLE IMPACT !!! ' + $event.data?.id);
      this.onFormBulkClose();
      this.showImpactsModal = true;
      this.$bvModal.show('article-impact-modal');
    } else {
      this.onFormBulkSaved($event);
    }
  }

  onCloseArticleImpactsModal() {
    console.log('impacts cleanup !!');
    this.articleDataForImpact = null;
    this.showImpactsModal = false;
    this.showImpactsButton = false;
    this.isProcessingImpacts = false;
    this.$refs.provider.getEntities();
  }

  onStartProcessingImpacts() {
    this.impactsAlertKey = this.impactsAlertKey + 1;
    this.isProcessingImpactsRunning = true;
    this.isProcessingImpactsEnded = false;
    this.isProcessingImpactsFailed = false;
    this.totalCount = 0;
    this.processedCount = 0;
  }

  listenToWebsocketArticleImpactChannel(): void {
    this.$bpcEcho
      .listenArticleImpactChannel()
      .listen('.BPC\\Accounting\\Events\\ArticleImpactPriceStarted', data => {
        this.isProcessingImpactsEnded = false;
        this.isProcessingImpactsFailed = false;
        this.isProcessingImpactsRunning = true;
        this.totalCount = data.totalCount || 0;
      })
      .listen('.BPC\\Accounting\\Events\\ArticleImpactPriceProcessed', data => {
        this.isProcessingImpactsRunning = !this.isProcessingImpactsEnded;
        this.totalCount = data.totalCount || 0;
        this.processedCount = data.processedCount || 0;
        this.ignoredCount = data.ignoredCount || 0;
      })
      // TODO Ignored event
      // .listen('.BPC\\Accounting\\Events\\CodaTransactionNotProcessed', data => {
      //   this.isImportingCodaFile = !this.codaFileImported;
      //   this.totalCodaTransactions = data.result?.totalTransactions || 0;
      //   this.totalCodaTransactionsImported = data.result?.totalImportedTransactions || 0;
      //   this.totalCodaTransactionsIgnored = data.result?.totalIgnoredTransactions || 0;
      // })
      .listen('.BPC\\Accounting\\Events\\ArticleImpactPriceEnded', data => {
        this.isProcessingImpactsEnded = true;
        this.isProcessingImpactsRunning = false;
        this.totalCount = data.totalCount || 0;
        this.processedCount = data.processedCount || 0;
        // this.ignoredCount = data.ignoredCount || 0;
        this.$refs.provider.getEntities();
      });
  }

  leaveWebsocketImportCodaFileChannel(): void {
    this.$bpcEcho.leaveArticleImpactChannel();
  }

  // updated() {}
  // destroyed() {}
}
